import { render, staticRenderFns } from "./RowColTextAreaField.vue?vue&type=template&id=3d9727e2"
import script from "./RowColTextAreaField.vue?vue&type=script&lang=js"
export * from "./RowColTextAreaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports